export function getUserOs(): string {
  return window.navigator.platform;
}
